import { Button, Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useStyles } from './styles'

export const ButtonExecution = ({ children, id, counter, cleanFilter, getExecutionDetalData, queryv2, lastVersionId, getVersionQuestionaire }: { children: any, id: any, counter: number | null, cleanFilter: () => void, getExecutionDetalData: (idversion: string, query?: string) => Promise<void>, queryv2: string, lastVersionId: string, getVersionQuestionaire:(query?:string) => Promise<void> }) => {
  const styles = useStyles()
  const { t } = useTranslation()

  const handleIconClick = () => {
    cleanFilter(); // Espera a que se limpie el filtro
    getVersionQuestionaire(); // Luego llama a getExecutionDetalData
  };

  return (
    <Grid container /* spacing={5} */ key={id}>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4} sx={styles.children}>{children}</Grid>
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4} sx={styles.main}>
        <Button /* disabled={!counter ? true:false} */ onClick={() => { getVersionQuestionaire(queryv2) }} variant="contained" sx={styles.aplly}>{t('Questionarie.apply')}</Button>

        {!!counter && <Button sx={styles.btn} variant='text_primary' onClick={() => { handleIconClick() }}>{t('general.cleanFilters')}</Button>}
      </Grid>
    </Grid>
  )
}